import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { VStack, Text, HStack, Input, InputGroup, InputRightElement, } from "@chakra-ui/react";
import { AlertIcon, TimesCircleIcon } from "./icons";
import { useCallback, useState } from "react";
import { Loading } from "./Loading";
export function Field({ error, touched, onClear, container, isLoading, ...inputProps }) {
    const [isActive, setIsActive] = useState(false);
    const onFocus = useCallback((e) => {
        setIsActive(true);
        inputProps.onFocus?.(e);
    }, [inputProps]);
    const onBlur = useCallback((e) => {
        setIsActive(false);
        inputProps.onBlur?.(e);
    }, [inputProps]);
    return (_jsxs(VStack, { align: "flex-start", ...container, children: [_jsxs(InputGroup, { children: [_jsx(Input, { ...inputProps, onFocus: onFocus, onBlur: onBlur, isInvalid: !!error && touched }), isLoading ? (_jsx(InputRightElement, { children: _jsx(Loading, { color: "text.secondary", size: "12px" }) })) : (inputProps.value &&
                        onClear && (_jsx(InputRightElement, { onClick: onClear, cursor: isActive ? "pointer" : "default", opacity: isActive ? 100 : 0, children: _jsx(TimesCircleIcon, { color: "text.secondary", boxSize: 5 }) })))] }), error && touched && (_jsxs(HStack, { marginY: 3, children: [_jsx(AlertIcon, { color: "text.error" }), _jsx(Text, { color: "text.error", fontSize: "sm", children: error })] }))] }));
}
//# sourceMappingURL=Field.js.map